import { useApi } from '@omnipresentgroup/api';
import type { GetTimeOffTypesAPIResponse } from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';
import { transformGetTimeOffTypesFromAPI } from '../mappers';

const TIME_OFF_TYPES_PATH = 'types';

export const getTimeOffTypesPath = (countryCode?: string) => [
  API_PATH,
  TIME_OFF_TYPES_PATH,
  countryCode,
];

export const useTimeOffTypes = ({
  countryCode,
  enabled = true,
}: {
  countryCode?: string;
  enabled?: boolean;
}) => {
  const { GET } = useApi();

  const query = useQuery({
    queryKey: getTimeOffTypesPath(countryCode),
    queryFn: () =>
      GET<GetTimeOffTypesAPIResponse>(
        `${API_BASE}/${API_PATH}/${TIME_OFF_TYPES_PATH}${
          countryCode ? `/${countryCode}` : ''
        }`,
      ),
    select: transformGetTimeOffTypesFromAPI,
    enabled,
  });

  return query;
};
